module.exports = __webpack_public_path__ + "static/media/Nucochem.51ca76ef.webp";